export const errorMessages = {
  AUTH_INVALID_CREDENTIALS: 'E-mail ou senha incorretos.',
  AUTH_TOKEN_MISSING: 'Sessão expirada. Faça login novamente.',
  AUTH_TOKEN_INVALID: 'Sessão inválida. Faça login novamente.',
  AUTH_TOKEN_EXPIRED: 'Sessão expirada. Faça login novamente.',
  AUTH_REFRESH_TOKEN_INVALID: 'Sessão expirada. Faça login novamente.',
  AUTH_REFRESH_TOKEN_REUSED: 'Sessão encerrada por segurança. Faça login novamente.',
  AUTH_INSUFFICIENT_PERMISSIONS: 'Você não tem permissão para esta ação.',
  VALIDATION_FAILED: 'Verifique os campos destacados.',
  DOMAIN_INVALID_CPF: 'CPF inválido. Verifique os dígitos.',
  DOMAIN_INVALID_CNPJ: 'CNPJ inválido. Verifique os dígitos.',
  VEHICLE_NOT_FOUND: 'Veículo não encontrado.',
  VEHICLE_DUPLICATE_PLATE: 'Já existe um veículo ativo com esta placa nesta oficina.',
  VEHICLE_OWNERSHIP_CONFLICT: 'Este veículo já está vinculado a um cliente nesta oficina.',
  VEHICLE_IDENTIFICATION_REQUIRED: 'Informe placa ou chassi.',
  VEHICLE_MODEL_REQUIRED: 'Selecione o modelo do veículo.',
  VEHICLE_BRAND_NOT_FOUND: 'Marca não encontrada. Cadastre a marca antes do modelo.',
  VEHICLE_BRAND_DUPLICATE: 'Já existe uma marca com este nome. Selecione a marca existente.',
  VEHICLE_MODEL_DUPLICATE:
    'Já existe um modelo com este nome nesta marca. Selecione o modelo existente.',
  VEHICLE_FIELD_IMMUTABLE: 'Este campo não pode ser alterado aqui.',
  VEHICLE_CHASSIS_IMMUTABLE: 'Chassi não pode ser alterado após o cadastro.',
  VEHICLE_ALREADY_RELEASED: 'Vínculo com este veículo já foi encerrado.',
  VEHICLE_RELEASE_NOTES_REQUIRED: 'Informe o motivo quando selecionar "Outro".',
  VEHICLE_TRANSFER_SAME_PARTY: 'Selecione um cliente diferente para a transferência.',
  VEHICLE_PARTY_NOT_ELIGIBLE: 'Cliente de destino inválido ou inativo.',
  VEHICLE_HAS_OPEN_ORDERS: 'Encerre ordens de serviço abertas antes de continuar.',
  VEHICLE_EXTERNAL_LOOKUP_NOT_FOUND: 'Placa não encontrada. Cadastre manualmente.',
  VEHICLE_PART_NOT_FOUND: 'Peça não encontrada.',
  VEHICLE_PART_PARTY_MISMATCH: 'Peça não pertence a este veículo ou cliente.',
  VEHICLE_PART_PARTY_IMMUTABLE: 'Não é possível alterar o cliente desta peça.',
  VEHICLE_PART_DUPLICATE_CONFIRMATION_REQUIRED:
    'Peça similar já cadastrada. Confirme para continuar.',
  VEHICLE_COMPONENT_NOT_FOUND: 'Componente não encontrado.',
  VEHICLE_COMPONENT_TYPE_NOT_FOUND: 'Tipo de componente inválido ou inativo.',
  VEHICLE_COMPONENT_DUPLICATE_CONFIRMATION_REQUIRED:
    'Componente similar já cadastrado. Confirme para continuar.',
  VEHICLE_COMPONENT_VEHICLE_IMMUTABLE: 'Não é possível mover o componente para outro veículo.',
  VEHICLE_MILEAGE_NOT_MONOTONIC: 'Quilometragem menor que a última leitura. Informe o motivo.',
  VEHICLE_USEFUL_LIFE_INFORMED_EXECUTION_INVALID:
    'Informe o KM e a data da troca feita fora da rede.',
  VEHICLE_MAINTENANCE_KM_REGRESSION: 'KM de manutenção inconsistente. Informe o motivo.',
  CUSTOMER_NOT_FOUND: 'Cliente não encontrado.',
  CUSTOMER_DUPLICATE_DOCUMENT: 'CPF/CNPJ já cadastrado nesta oficina.',
  CUSTOMER_INVALID_PASSPORT:
    'Documento / passaporte inválido. Informe ao menos 3 caracteres alfanuméricos.',
  CUSTOMER_PARTY_NOT_ACTIVE: 'Cadastro arquivado ou inativo.',
  CUSTOMER_ROLE_ALREADY_EXISTS: 'Este cadastro já possui papel de cliente.',
  CUSTOMER_ROLE_NOT_ELIGIBLE_FOR_OS: 'Cliente não pode abrir nova OS neste status.',
  CUSTOMER_ADDRESS_INVALID: 'Endereço inválido. Verifique cidade e estado.',
  GEO_CITY_NOT_FOUND: 'Cidade não encontrada no catálogo.',
  GEO_STATE_NOT_FOUND: 'Estado não encontrado no catálogo.',
  GEO_CITY_IBGE_CONFLICT: 'Este código IBGE já está em outra cidade.',
  CUSTOMER_CONTACT_OWNER_INVALID: 'Contato com vínculo inválido.',
  CUSTOMER_PLACE_TENANT_MISMATCH: 'Unidade inválida para este cadastro.',
  CUSTOMER_PLACE_CUSTOMER_NOT_FOUND: 'Vínculo com a unidade não encontrado.',
  CUSTOMER_PLACE_LINK_ALREADY_EXISTS: 'Cliente já vinculado a esta unidade.',
  CUSTOMER_PLACE_LINK_NOT_DELETED: 'Vínculo com a unidade ainda está ativo.',
  CUSTOMER_CREDIT_LIMIT_INVALID: 'Informe um limite de crédito válido (maior ou igual a zero).',
  CUSTOMER_CREDIT_EXCEEDED: 'Operação excede o crédito disponível do cliente.',
  CUSTOMER_MARKETING_NOT_CONSENTED: 'Cliente não autorizou comunicações de marketing.',
  CUSTOMER_BIRTH_DATE_IN_FUTURE: 'Data de nascimento não pode ser futura.',
  PRODUCT_NOT_FOUND: 'Item de catálogo não encontrado.',
  PRODUCT_TAXONOMY_TENANT_MISMATCH: 'Taxonomia inválida para este cadastro.',
  PRODUCT_TAXONOMY_SLUG_DUPLICATE: 'Esta referência já está em uso.',
  PRODUCT_TAXONOMY_SLUG_IMMUTABLE: 'A referência não pode ser alterada após homologação.',
  PRODUCT_TAXONOMY_NOT_FOUND: 'Taxonomia não encontrada.',
  PRODUCT_TAXONOMY_CUSTOM_CONFLICTS_GLOBAL:
    'Este nome ou código já existe no catálogo ZR. Use o item da lista.',
  CATALOG_GLOBAL_TAXONOMY_WRITE_FORBIDDEN:
    'Itens do catálogo ZR não podem ser editados ou excluídos.',
  PRODUCT_INVALID_TAXONOMY_SLUG: 'Formato de referência inválido.',
  PRODUCT_CATEGORY_NOT_FOUND: 'Categoria não encontrada.',
  PRODUCT_CATEGORY_INHERITED_NAME_LOCKED: 'O nome desta categoria acompanha o catálogo global.',
  PRODUCT_CATEGORY_PARENT_NOT_FOUND: 'Categoria pai não encontrada.',
  PRODUCT_MEASUREMENT_UNIT_NOT_FOUND: 'Unidade de medida não encontrada.',
  PRODUCT_MEASUREMENT_UNIT_CODE_DUPLICATE: 'Código de unidade de medida já cadastrado.',
  PRODUCT_INVALID_MEASUREMENT_UNIT_CODE: 'Código de unidade de medida inválido.',
  PRODUCT_ACCOUNT_KEY_INVALID: 'Selecione uma conta analítica ativa do plano.',
  PRODUCT_SKU_REQUIRED: 'Informe o SKU para produtos com controle de estoque.',
  PRODUCT_SKU_DUPLICATE: 'SKU já cadastrado nesta oficina.',
  PRODUCT_NOT_ELIGIBLE: 'Item inativo ou bloqueado para esta operação.',
  PRODUCT_STOCK_NOT_CONTROLLED: 'Este produto não possui controle de estoque.',
  PRODUCT_PLACE_TENANT_MISMATCH: 'Unidade inválida para este produto.',
  PRODUCT_NOT_ENABLED_AT_PLACE: 'Produto não habilitado nesta unidade.',
  PRODUCT_RELATION_INVALID: 'Vínculo de catálogo inválido.',
  PRODUCT_CATEGORY_CYCLE: 'Hierarquia de categorias inválida.',
  CATALOG_CATEGORY_NOT_FOUND: 'Categoria global não encontrada.',
  CATALOG_CATEGORY_DEPTH_EXCEEDED: 'A profundidade máxima da taxonomia é 3.',
  CATALOG_CATEGORY_CYCLE: 'Não é possível mover a categoria para dentro dela mesma.',
  CATALOG_CATEGORY_SLUG_DUPLICATE: 'Esta referência já está em uso na taxonomia global.',
  CATALOG_CATEGORY_SLUG_IMMUTABLE:
    'A referência não pode ser alterada após haver filho ou genérico vinculado.',
  CATALOG_CATEGORY_IN_USE: 'Não é possível arquivar enquanto houver filho ou genérico vinculado.',
  CATALOG_GENERIC_PRODUCT_NOT_FOUND: 'Produto genérico não encontrado.',
  CATALOG_GENERIC_SERVICE_NOT_FOUND: 'Serviço genérico não encontrado.',
  CATALOG_GENERIC_PRODUCT_INVALID: 'Produto genérico inválido.',
  CATALOG_GENERIC_PRODUCT_NAME_DUPLICATE: 'Já existe um genérico com este nome canônico.',
  CATALOG_GENERIC_PRODUCT_TAX_CODE_INVALID:
    'NCM ou CEST informado não é válido no catálogo fiscal.',
  CATALOG_GENERIC_PRODUCT_ATTRIBUTE_SCHEMA_INVALID: 'Schema de atributos do genérico é inválido.',
  CATALOG_GENERIC_PRODUCT_IN_USE:
    'Não é possível arquivar enquanto houver peça concreta vinculada.',
  CATALOG_PRODUCT_VEHICLE_APPLICATION_INVALID: 'Aplicação veicular da peça inválida.',
  CATALOG_PRODUCT_ATTRIBUTE_VALUE_INVALID: 'Valor de atributo inválido para o schema do genérico.',
  CATALOG_PRODUCT_REQUIRED_ATTRIBUTES_MISSING:
    'Preencha os atributos obrigatórios do genérico antes de verificar.',
  CATALOG_PRODUCT_GENERIC_REQUIRED: 'Selecione um produto genérico vigente para cadastrar a peça.',
  CATALOG_PRODUCT_TENANT_SCOPED_FIELD:
    'Preço, custo, estoque, SKU e fiscal não entram na camada global.',
  CATALOG_PRODUCT_NOT_FOUND: 'Peça do catálogo global não encontrada.',
  CATALOG_PRODUCT_IDENTITY_CONFLICT: 'Já existe uma peça ativa com este EAN ou marca+MPN.',
  CATALOG_PRODUCT_IDENTITY_REQUIRED: 'Informe EAN/GTIN ou fabricante e MPN.',
  CATALOG_PRODUCT_INVALID_TRANSITION: 'Esta peça mesclada não pode ser editada.',
  CATALOG_MANUFACTURER_NOT_FOUND: 'Fabricante não encontrado.',
  CATALOG_MANUFACTURER_SLUG_DUPLICATE: 'Já existe um fabricante com este nome.',
  CATALOG_MANUFACTURER_IN_USE:
    'Não é possível arquivar enquanto houver peça concreta vinculada a este fabricante.',
  CATALOG_INHERITED_FIELD_LOCKED: 'Este campo é herdado do genérico e não pode ser divergido.',
  CATALOG_USEFUL_LIFE_TARGET_INVALID:
    'Só é possível aplicar vida útil a produtos e serviços da oficina.',
  SERVICE_LIFECYCLE_FIELD_INVALID: 'Informe um valor inteiro maior ou igual a zero.',
  SERVICE_PRICING_INVALID:
    'Valores do serviço inválidos. Revise modelo, preços não negativos e desconto máximo de 0% a 100%.',
  SERVICE_PRICING_MODEL_REQUIRED:
    'Informe o modelo de preço (fechado ou por hora) para gravar custo, preço, taxa ou desconto.',
  SERVICE_COST_ACCOUNT_NOT_THIRD_PARTY:
    'Conta de custo só pode ser informada em serviço de terceiros.',
  SERVICE_COMMISSION_RATE_INVALID: 'Informe um percentual de comissão maior que zero.',
  PRODUCT_VEHICLE_APPLICATION_INVALID: 'Aplicação veicular inválida.',
  SERVICE_VEHICLE_APPLICATION_INVALID: 'Aplicação veicular inválida.',
  APPLICABLE_CATALOG_MANUFACTURE_YEAR_REQUIRED:
    'Informe o ano de fabricação para listar itens aplicáveis.',
  PRODUCT_MEASUREMENT_UNIT_REQUIRED: 'Informe a unidade de medida para produtos com estoque.',
  SERVICE_CATEGORY_REQUIRED_FOR_OG: 'Classifique o serviço com categoria para esta rede.',
  KIT_NOT_FOUND: 'Kit não encontrado.',
  KIT_NOT_DRAFT: 'Operação permitida apenas em rascunho.',
  KIT_DRAFT_NOT_OWNED: 'Rascunho pertence a outro usuário.',
  KIT_COMPOSITION_INVALID: 'Composição inválida. Verifique itens, quantidades e duplicidades.',
  KIT_PRICE_ADJUSTMENT_INVALID: 'Ajuste de preço inválido. Verifique tipo e valor.',
  KIT_SLOT_COMPOSITION_INVALID:
    'Composição SLOT inválida. Informe categorias, quantidades e pesos de rateio.',
  KIT_SLOT_NO_CANDIDATES:
    'Há slot sem candidatos elegíveis para o veículo/unidade. Ajuste o catálogo ou o fitment.',
  KIT_SLOT_SELECTION_REQUIRED: 'Escolha o item de cada slot com mais de um candidato.',
  REVISION_PLAN_NOT_FOUND: 'Plano de revisão não encontrado.',
  REVISION_PLAN_COMPOSITION_INVALID:
    'Composição do plano inválida. Informe ao menos um produto genérico vigente.',
  MAINTENANCE_CHECKLIST_NOT_FOUND: 'Check-list de manutenção não encontrado.',
  MAINTENANCE_CHECKLIST_COMPOSITION_INVALID:
    'Check-list inválido: revise nome, categorias e itens (sem repetição, cada categoria com ao menos um item).',
  MAINTENANCE_CHECKLIST_ITEM_MISMATCH: 'A peça escolhida não pertence ao item do check-list.',
  PRODUCT_PRICE_POLICY_INVALID:
    'Faixas da política inválidas. Cubra de R$ 0,00 sem furo nem sobreposição, com markup maior ou igual a zero.',
  PRODUCT_PRICE_POLICY_NOT_FOUND: 'Nenhuma política default de peça cadastrada.',
  PRODUCT_PRICE_OVERRIDE_INVALID:
    'Exceção inválida. Informe markup maior ou igual a zero ou um preço fechado maior ou igual a zero.',
  PRODUCT_PRICE_OVERRIDE_NOT_FOUND: 'Exceção de preço não encontrada.',
  PRODUCT_PRICE_PROMOTION_OVERLAP:
    'Já existe promoção vigente neste alvo desta unidade. Encerre ou ajuste a vigência.',
  PRODUCT_PRICE_PROMOTION_INVALID:
    'Promoção inválida. Informe desconto de 0% a 100% e uma vigência com início antes do fim.',
  PRODUCT_PRICE_PROMOTION_NOT_FOUND: 'Promoção de preço não encontrada.',
  SUPPLIER_NOT_FOUND: 'Fornecedor não encontrado.',
  SUPPLIER_ALREADY_EXISTS: 'Este cadastro já possui perfil de fornecedor.',
  SUPPLIER_PARTY_NOT_ACTIVE: 'Cadastro arquivado ou inativo.',
  SUPPLIER_PAYMENT_TERMS_INVALID: 'Condição de pagamento inválida. Verifique o prazo.',
  SUPPLIER_ROLE_NOT_ELIGIBLE: 'Fornecedor inativo ou bloqueado para esta operação.',
  SUPPLIER_SERVICE_KIND_NOT_FOUND: 'Tipo de serviço não encontrado.',
  SUPPLIER_CAPABILITY_ALREADY_EXISTS: 'Capacidade já cadastrada para este fornecedor.',
  SUPPLIER_PRODUCT_ALREADY_LINKED: 'Produto já vinculado a este fornecedor.',
  HTTP_ERROR: 'Não foi possível concluir a operação. Tente novamente.',
  INTERNAL_ERROR: 'Não foi possível concluir. Entre em contato com o suporte.',
  PLATFORM_OPERATOR_REQUIRED: 'Acesso restrito ao console da plataforma.',
  PLATFORM_ORG_REQUIRES_PLACE: 'Inclua ao menos uma unidade no provisionamento.',
  PLATFORM_TENANT_SLUG_CONFLICT: 'Este slug já está em uso. Escolha outro identificador.',
  PLATFORM_TENANT_DOCUMENT_CONFLICT: 'CNPJ já cadastrado em outra organização.',
  PLATFORM_EXTERNAL_LOOKUP_NOT_FOUND:
    'CNPJ não encontrado na Receita. Preencha a ficha manualmente.',
  PLATFORM_EXTERNAL_LOOKUP_UNAVAILABLE:
    'Consulta à Receita indisponível. Preencha a ficha manualmente ou tente de novo.',
  PLATFORM_PLACE_CNPJ_CONFLICT: 'CNPJ de unidade já cadastrado.',
  PLATFORM_ORG_PLACE_CNPJ_MISMATCH: 'Apenas uma unidade pode usar o CNPJ da organização.',
  PLATFORM_OG_MEMBERSHIP_REQUIRES_PLACES:
    'Selecione ao menos uma unidade para vincular a organização à rede.',
  ORG_GROUP_SLUG_CONFLICT: 'Este slug de rede já está em uso.',
  ORG_GROUP_NOT_FOUND: 'Rede não encontrada.',
  ORG_GROUP_MEMBERSHIP_ALREADY_EXISTS: 'Esta organização já está vinculada à rede.',
  PLATFORM_BOOTSTRAP_ADMIN_ALREADY_EXISTS:
    'Já existe um administrador bootstrap para esta organização.',
  PLATFORM_LOCAL_ONLY_OPERATION: 'Esta ação só está disponível no ambiente local.',
  FISCAL_LOCAL_ONLY_OPERATION: 'Esta ação só está disponível no ambiente local.',
  PLATFORM_BOOTSTRAP_INVITE_NOT_FOUND: 'Não há convite bootstrap nesta organização.',
  PLATFORM_ORG_USER_INVITE_NOT_FOUND: 'Não há convite pendente deste usuário nesta organização.',
  IDENTITY_INVITE_INVALID: 'Este link de convite é inválido ou expirou.',
  IDENTITY_INVITE_ALREADY_ACCEPTED: 'Este convite já foi aceito.',
  PLATFORM_PROFILE_TEMPLATE_NOT_FOUND: 'Template de perfil da plataforma não encontrado.',
  PLATFORM_PROFILE_TEMPLATE_SLUG_CONFLICT: 'Este slug de perfil global já está em uso.',
  PLATFORM_PROFILE_TEMPLATE_IMMUTABLE_FIELD:
    'Slug e escopo do perfil global não podem ser alterados.',
  PLATFORM_LAST_PLACE_REQUIRES_CONFIRMATION:
    'Confirme explicitamente a inativação da última unidade ativa.',
  PLATFORM_ORG_INACTIVE: 'Esta organização está inativa.',
  PLATFORM_ORG_DOCUMENT_IMMUTABLE:
    'Tipo e documento da organização não podem ser alterados nesta edição.',
  PLATFORM_ORG_INDIVIDUAL_SINGLE_PLACE:
    'Uma organização de pessoa física tem exatamente uma unidade.',
  PLATFORM_ORG_FISCAL_DISABLED:
    'O módulo fiscal fica desligado enquanto a organização for pessoa física.',
  PLATFORM_ORG_NOT_INDIVIDUAL: 'Esta organização já é pessoa jurídica.',
  PLATFORM_ORG_COMPLETION_FORBIDDEN:
    'Somente o administrador da organização pode concluir o cadastro como pessoa jurídica.',
  PLATFORM_NETWORK_INACTIVE: 'Esta rede está inativa.',
  PLATFORM_PERMISSION_GROUP_NOT_FOUND: 'Perfil não encontrado para este alvo.',
  IDENTITY_PERMISSION_GROUP_SCOPE_INCONSISTENT:
    'Este perfil não é compatível com o escopo selecionado.',
  IDENTITY_PLACE_NOT_IN_TENANT: 'A unidade não pertence a esta organização.',
  IDENTITY_PLACE_NOT_FOUND: 'Unidade não encontrada.',
  IDENTITY_MIXED_ACCESS_SCOPES: 'Este usuário já tem acesso em outro tipo de escopo.',
  IDENTITY_TENANT_NOT_FOUND: 'Organização não encontrada.',
  PLACE_DOCUMENT_NUMBER_IMMUTABLE: 'CNPJ da unidade não é editável.',
  IDENTITY_PLACE_SLUG_CONFLICT: 'Este slug de unidade já está em uso nesta organização.',
  IDENTITY_USER_ALREADY_EXISTS: 'Já existe um usuário com este e-mail.',
  IDENTITY_WORKSHOP_PLACE_REQUIRED: 'Você precisa de acesso a uma unidade ativa.',
  IDENTITY_PLACE_INACTIVE: 'Esta unidade está inativa. Escolha outra unidade ativa.',
  IDENTITY_LAST_ACCESS_MANAGER:
    'A organização precisa manter ao menos um usuário ativo com gestão de acessos.',
  IDENTITY_RESET_TOKEN_INVALID: 'Este link expirou ou é inválido. Peça um novo.',
  APPOINTMENT_NOT_FOUND: 'Agendamento não encontrado.',
  APPOINTMENT_VEHICLE_REQUIRED: 'Escolha um veículo cadastrado nesta oficina.',
  APPOINTMENT_VEHICLE_NOT_FOUND: 'Este veículo não pertence ao cliente nesta oficina.',
  APPOINTMENT_DATE_INVALID: 'Escolha um dia futuro.',
  APPOINTMENT_PLACE_CLOSED: 'A oficina não recebe veículos neste dia.',
  APPOINTMENT_DAY_FULL: 'Não há mais vagas neste dia. Escolha outro.',
  APPOINTMENT_VEHICLE_DAY_TAKEN: 'Este veículo já tem agendamento nesta unidade neste dia.',
  APPOINTMENT_INVALID_TRANSITION: 'Este agendamento não pode ser alterado agora.',
  APPOINTMENT_AWAITING_CUSTOMER: 'Este agendamento espera a confirmação do cliente.',
  APPOINTMENT_RESCHEDULE_PENDING:
    'Já existe uma proposta de nova data aguardando o cliente. Cancele o agendamento ou espere o aceite.',
  APPOINTMENT_RESCHEDULE_DAY_FULL: 'O dia proposto já encheu. O agendamento foi cancelado.',
  APPOINTMENT_NO_PENDING_RESCHEDULE: 'Não há proposta de remarcação neste agendamento.',
  APPOINTMENT_PLACE_REQUIRED: 'Informe a unidade da oficina.',
  INVENTORY_INBOUND_CONFERENCE_INVALID:
    'A conferência de entrada está inválida ou não pertence a esta unidade.',
  INVENTORY_INBOUND_PRODUCT_UNMATCHED:
    'Cadastre ou vincule o produto antes de conferir esta linha.',
  INVENTORY_INBOUND_CONFERENCE_INCOMPLETE:
    'Vincule e confira todas as linhas antes de finalizar a entrada.',
  INVENTORY_POLICY_INVALID: 'Política de estoque inválida. Verifique o valor informado.',
  INVENTORY_LOT_INVOICE_ALLOCATION_DUPLICATE:
    'Esta linha da nota fiscal já foi alocada neste lote.',
  PURCHASING_QUOTE_NOT_FOUND: 'Cotação de compra não encontrada.',
  PURCHASING_PO_NOT_FOUND: 'Pedido de compra não encontrado.',
  PURCHASING_PO_INVALID_STATE: 'Operação não permitida para o status atual do pedido.',
  PURCHASING_RECEIPT_QUANTITY_INVALID: 'Quantidade recebida excede a quantidade pedida.',
  PURCHASING_PHYSICAL_STOCK_ENTRY_ALREADY_DONE: 'A entrada física desta linha já foi registrada.',
  PURCHASING_PHYSICAL_STOCK_ENTRY_STORAGE_REQUIRED:
    'Selecione o armazém para dar entrada no estoque.',
  PURCHASING_QUOTE_EMPTY: 'A cotação precisa de ao menos um item.',
  PURCHASING_QUOTE_NO_SUPPLIER: 'Convide ao menos um fornecedor antes de enviar.',
  PURCHASING_QUOTE_RESPONSE_INVALID:
    'Só é possível registrar resposta de fornecedor convidado nesta cotação.',
  PURCHASING_QUOTE_ITEM_PRODUCT_REQUIRED: 'Selecione a peça no catálogo.',
  PURCHASING_QUOTE_ITEM_REFERENCE_INVALID:
    'Informe exatamente um entre peça da unidade e peça genérica.',
  PURCHASING_QUOTE_OFFER_INVALID: 'Marca duplicada ou quantidade ofertada inválida.',
  PURCHASING_QUOTE_ALLOCATION_INVALID: 'Quantidade alocada excede a ofertada ou a pedida.',
  PURCHASING_QUOTE_SELECTION_INVALID: 'Seleção incompleta ou inconsistente.',
  PURCHASING_QUOTE_INVALID_STATE: 'Operação não permitida para o status atual da cotação.',
  PURCHASING_QUOTE_SEED_INVALID:
    'Seleção inválida para abrir a cotação. Inclua só peças com produto de catálogo.',
  PURCHASING_QUOTE_ORIGIN_LOCKED:
    'Itens desta cotação vêm do orçamento de origem e não podem ser alterados.',
  PURCHASING_QUOTE_ORIGIN_BLOCKS_PO:
    'Esta cotação veio do orçamento. Devolva ao orçamento e gere os pedidos pela OS.',
  SERVICE_ORDER_OPEN_QUOTE_GENERATE_EMPTY: 'Não há peças cotadas e aprovadas para gerar pedido.',
  SERVICE_QUOTE_NOT_FOUND: 'Orçamento não encontrado.',
  SERVICE_QUOTE_ATTACHMENT_NOT_FOUND: 'Anexo do orçamento não encontrado.',
  SERVICE_QUOTE_EMPTY: 'Adicione ao menos um item antes de enviar.',
  SERVICE_QUOTE_EXPIRED: 'Orçamento expirado. Crie uma nova versão.',
  SERVICE_QUOTE_RECEPTION_REQUIRED: 'Inicie o check-in antes de enviar ou aprovar.',
  SERVICE_QUOTE_ALREADY_CONVERTED: 'Este orçamento já tem check-in.',
  SERVICE_QUOTE_UNBOUND_EXPIRED: 'Este orçamento sem check-in expirou. Abra um novo.',
  SERVICE_QUOTE_VERSION_LOCKED: 'Orçamento bloqueado para edição. Crie uma nova versão.',
  SERVICE_QUOTE_SELLER_INVALID: 'Selecione um colaborador vinculado a esta unidade.',
  SERVICE_QUOTE_REJECTED_ITEM_NOT_REUSABLE:
    'Este item recusado não pode mais ser adicionado a este orçamento.',
  SERVICE_QUOTE_ITEM_DEPENDENCY_UNMET: 'Aprove a peça dependente junto com o serviço.',
  SERVICE_QUOTE_ITEM_NOT_FOUND: 'Linha do orçamento não encontrada.',
  SERVICE_QUOTE_ITEM_PRICE_REQUIRED: 'Informe um preço maior que zero no serviço genérico.',
  SERVICE_ORDER_ITEM_REFERENCE_INVALID: 'Referência de produto ou serviço inválida.',
  SERVICE_ORDER_NOT_FOUND: 'Ordem de serviço não encontrada.',
  SERVICE_ORDER_SNAPSHOT_IMMUTABLE: 'Ordem encerrada — alterações não permitidas.',
  SERVICE_ORDER_ITEM_INVALID_EXECUTION_TRANSITION: 'Transição de execução inválida para este item.',
  SERVICE_ORDER_ITEM_CLIENT_APPROVAL_REQUIRED:
    'Aguarde a aprovação do cliente antes de avançar a execução.',
  SERVICE_ORDER_ITEM_CUSTOMER_ALREADY_DECIDED: 'Este item já possui decisão do cliente.',
  SERVICE_ORDER_ITEM_TARGET_INVALID: 'Defina o alvo do serviço antes de aplicar.',
  SERVICE_ORDER_EXTERNAL_TIMING_INVALID:
    'Registro externo inválido — envio deve preceder o retorno.',
  SERVICE_ORDER_ITEM_NOT_FOUND: 'Linha da ordem de serviço não encontrada.',
  SERVICE_ORDER_ITEM_NOT_REMOVABLE: 'Este item já faz parte do orçamento e não pode ser excluído.',
  SERVICE_ORDER_ITEM_ALREADY_IN_EXECUTION: 'Este item já está em execução e não pode ser excluído.',
  SERVICE_ORDER_ITEM_OPEN_PURCHASE:
    'Este item tem pedido de compra em andamento e não pode ser excluído.',
  SERVICE_ORDER_INVALID_STATUS_TRANSITION: 'Transição de status não permitida para esta OS.',
  SERVICE_ORDER_DELIVERY_CREDIT_BLOCKED: 'Entrega bloqueada por crédito do cliente.',
  SERVICE_ORDER_CHECKOUT_CHECKLIST_INVALID: 'Complete o checklist de saída antes de entregar.',
  SERVICE_ORDER_SIGNATURE_REQUIRED:
    'Colete a assinatura do termo de entrega ou aguarde o aceite do titular no app.',
  SERVICE_ORDER_CHECKOUT_NOT_AWAITING_CUSTOMER:
    'O check-out ainda não está aguardando decisão do titular.',
  SERVICE_ORDER_CHECKOUT_CUSTOMER_ALREADY_DECIDED: 'O titular já decidiu este check-out.',
  SERVICE_ORDER_CHECKOUT_REJECTION_REASON_REQUIRED: 'Informe o motivo da recusa do check-out.',
  SERVICE_DOCUMENT_SEQUENCE_CONFLICT: 'Não foi possível gerar o número do check-in. Tente de novo.',
  SERVICE_RECEPTION_TARGET_INVALID: 'Alvo da recepção inválido.',
  SERVICE_RECEPTION_TARGET_PARTY_MISMATCH: 'O veículo não pertence ao cliente selecionado.',
  SERVICE_RECEPTION_ROLE_INVALID: 'Papel de cliente inválido para esta recepção.',
  SERVICE_RECEPTION_ALREADY_HAS_ORDER: 'Esta recepção já possui ordem de serviço.',
  SERVICE_RECEPTION_NOT_FOUND: 'Recepção não encontrada.',
  SERVICE_RECEPTION_MINIMUM_REQUIRED: 'Informe KM de entrada e relato do cliente.',
  SERVICE_RECEPTION_CHECKLIST_INVALID: 'Complete o checklist antes de concluir o check-in.',
  SERVICE_RECEPTION_FUEL_LEVEL_INVALID: 'Nível de combustível deve ser entre 0 e 8.',
  SERVICE_RECEPTION_SIGNATURE_REQUIRED: 'Colete a assinatura do termo antes de concluir.',
  SERVICE_RECEPTION_TERM_REQUIRED: 'Salve o termo de recepção antes de concluir.',
  SERVICE_RECEPTION_TERM_INVALID: 'O termo de recepção está em formato inválido.',
  SERVICE_RECEPTION_TERM_LOCKED: 'O termo não pode ser editado após a assinatura.',
  SERVICE_RECEPTION_TITULAR_APP_REQUIRED:
    'Este cliente não tem o app ativo. Colete a assinatura presencial.',
  SERVICE_ORDER_TITULAR_APP_REQUIRED:
    'Este cliente não tem o app ativo. Colete a assinatura presencial.',
  SERVICE_RECEPTION_ALREADY_COMPLETED: 'Este check-in já foi concluído.',
  SERVICE_RECEPTION_VEHICLE_ALREADY_OPEN:
    'Este veículo já tem um check-in em andamento nesta unidade.',
  SERVICE_ENTRY_ODOMETER_BELOW_VEHICLE:
    'KM de entrada não pode ser menor que o KM atual do veículo.',
  SERVICE_RECEPTION_NOT_CANCELLABLE: 'Só é possível anular um check-in em andamento.',
  SERVICE_QUOTE_NOT_CANCELLABLE: 'Este orçamento não está em rascunho e não pode ser cancelado.',
  SERVICE_ORDER_MECHANIC_INVALID: 'Mecânico inválido para esta unidade.',
  SERVICE_ORDER_ITEM_MECHANIC_REQUIRED:
    'Atribua um mecânico ao item de serviço antes de avançar a execução.',
  SERVICE_ORDER_WORKBAY_NOT_AVAILABLE: 'Box/vaga indisponível — escolha outro.',
  SERVICE_ORDER_TIME_ENTRY_INVALID: 'Apontamento inválido para este item.',
  SERVICE_ORDER_TIME_ENTRY_ALREADY_OPEN:
    'Já existe um cronômetro aberto — encerre antes de iniciar outro.',
  FISCAL_TAX_PROFILE_OVERLAP: 'Já existe perfil tributário vigente neste período.',
  FISCAL_PRODUCT_PROFILE_OVERLAP: 'Já existe perfil fiscal de produto vigente neste período.',
  FISCAL_PRODUCT_PROFILE_SUGGESTION_NOT_FOUND:
    'Não há sugestão de perfil tributário pendente para este produto.',
  FISCAL_SERVICE_PROFILE_NOT_FOUND:
    'Este serviço não tem perfil fiscal vigente. Cadastre o perfil do serviço antes de emitir.',
  FISCAL_SERVICE_PROFILE_OVERLAP: 'Já existe perfil fiscal de serviço vigente neste período.',
  FISCAL_CERTIFICATE_CNPJ_MISMATCH: 'CNPJ do certificado não confere com o da filial.',
  FISCAL_CERTIFICATE_STORAGE_NOT_FOUND:
    'Arquivo do certificado não encontrado. Envie o arquivo novamente.',
  FISCAL_EMISSION_SUSPENDED:
    'Emissões novas desta filial estão suspensas. Libere a emissão nas configurações da filial.',
  FISCAL_ENVIRONMENT_SWITCH_IN_FLIGHT:
    'Há emissão ou cancelamento em andamento. Aguarde o resultado antes de trocar o ambiente.',
  FISCAL_DOCUMENT_ENVIRONMENT_MISMATCH:
    'Esta nota nasceu em outro ambiente. Volte o ambiente da filial ou emita uma nota nova.',
  FISCAL_HOMOLOGATION_SAMPLE_INCOMPLETE:
    'Para ativar produção, emita 5 notas em homologação com valores e produtos diferentes.',
  FISCAL_ISSUER_NOT_SYNCED:
    'A filial ainda não está sincronizada com o processador fiscal. Ative a emissão na parametrização.',
  FISCAL_DFE_ISSUER_NOT_SYNCED:
    'A filial ainda não está sincronizada com o processador DFe. Sincronize o emitente DFe na parametrização.',
  FISCAL_DFE_ISSUER_SYNC_FAILED: 'Falha ao sincronizar a filial com o processador DFe.',
  FISCAL_NFSE_ISSUER_NOT_SYNCED:
    'A filial ainda não está sincronizada com o processador NFS-e Nacional. Ative a emissão NFS-e na parametrização.',
  FISCAL_NFSE_ISSUER_SYNC_FAILED: 'Falha ao sincronizar a filial com o processador NFS-e Nacional.',
  FISCAL_NFSE_MUNICIPAL_NOT_SUPPORTED:
    'Emissão municipal legado não é suportada neste canal. Use apenas NFS-e Nacional.',
  FISCAL_NFSE_PAYLOAD_INCOMPLETE:
    'Dados incompletos para NFS-e. Complete tomador, ISS ou pagamento e tente de novo.',
  FISCAL_DFE_DISTRIBUTION_FAILED: 'A consulta de distribuição DFe falhou. Tente novamente.',
  FISCAL_DFE_DISTRIBUTION_BLOCKED:
    'Consulta de distribuição bloqueada até o horário liberado. Aguarde o cooldown e tente de novo.',
  FISCAL_DFE_INBOX_DOCUMENT_NOT_FOUND: 'Documento da caixa de entrada não encontrado.',
  FISCAL_DFE_MANIFESTATION_ALREADY_IN_FLIGHT:
    'Já existe uma manifestação em andamento para este documento. Aguarde o resultado.',
  FISCAL_DFE_MANIFESTATION_JUSTIFICATION_INVALID:
    'Justificativa inválida para operação não realizada (15 a 255 caracteres).',
  FISCAL_DFE_XML_NOT_AVAILABLE:
    'XML completo ainda não disponível. Aguarde a distribuição ou manifeste ciência.',
  FISCAL_INBOUND_CNPJ_MISMATCH: 'O destinatário da NF-e não corresponde ao CNPJ da filial ativa.',
  FISCAL_INBOUND_INVALID_XML: 'O XML da NF-e é inválido ou está incompleto.',
  FISCAL_INBOUND_DUPLICATE_ACCESS_KEY: 'Esta NF-e já foi registrada.',
  FISCAL_INBOUND_SUPPLIER_REQUIRED:
    'Cadastre o fornecedor identificado pelo CNPJ do emitente antes de continuar.',
  FISCAL_INBOUND_SUPPLIER_CNPJ_MISMATCH:
    'O fornecedor selecionado não corresponde ao CNPJ do emitente da NF-e.',
  FISCAL_INBOUND_CONFERENCE_INCOMPLETE:
    'Conclua a conferência de estoque antes de finalizar esta entrada.',
  FISCAL_INBOUND_INVALID_OPERATIONAL_STATUS:
    'Esta entrada não está mais aguardando conferência. Recarregue os dados.',
  FISCAL_INBOUND_CANCEL_NOT_ALLOWED:
    'Esta entrada não pode ser cancelada (já finalizada ou status inválido).',
  FISCAL_INBOUND_CANCEL_JUSTIFICATION_INVALID:
    'Informe uma justificativa entre 15 e 255 caracteres para cancelar a entrada.',
  FISCAL_INBOUND_ALREADY_CANCELLED: 'Esta entrada já foi cancelada.',
  FINANCE_INBOUND_CANCEL_BLOCKED_PAID:
    'Há contas a pagar já baixadas ligadas a esta NF. Estorne as baixas antes de cancelar.',
  FINANCE_COMMISSION_RATE_INVALID:
    'Percentual inválido ou a base está desligada na matriz da unidade.',
  FINANCE_COLLABORATOR_WAGE_INVALID:
    'Salário inválido. Informe um valor maior que zero e uma competência AAAA-MM.',
  FINANCE_COMMISSION_POLICY_INVALID:
    'Política de comissão inválida. Revise a matriz e o trancamento.',
  INVENTORY_INBOUND_CANCEL_BLOCKED_STOCK:
    'Há linhas de conferência com saldo em estoque. Reverta o estoque antes de cancelar.',
  FISCAL_SECRET_REQUIRED: 'Senha do certificado ou CSC NFC-e ausente. Complete o cadastro fiscal.',
  FISCAL_ISSUER_SYNC_FAILED: 'Falha ao sincronizar a filial com o processador fiscal.',
  FISCAL_ISSUER_SYNC_PRECONDITION:
    'Complete anatomia, perfil tributário, certificado, senha e CSC antes de sincronizar.',
  FISCAL_SEQUENCE_REWIND_FORBIDDEN:
    'O número informado não pode ser menor que o contador atual da filial.',
  OBJECT_STORAGE_INVALID_CONTENT_TYPE: 'Tipo de arquivo não suportado para upload.',
  OBJECT_STORAGE_FILE_TOO_LARGE: 'Arquivo excede o tamanho máximo permitido.',
  OBJECT_STORAGE_UPLOAD_FAILED: 'Falha ao enviar o arquivo. Tente novamente.',
  FISCAL_OPERATION_DEFINITION_NOT_FOUND: 'Definição de operação não encontrada no catálogo.',
  FISCAL_OPERATION_INCOMPATIBLE:
    'A operação fiscal selecionada não corresponde ao tipo de nota que será gerada.',
  FISCAL_OPERATION_NOT_ENABLED: 'Operação não habilitada para o tenant.',
  FISCAL_CFOP_DIRECTION_MISMATCH: 'CFOP incompatível com a direção da operação.',
  FISCAL_GLOBAL_CATALOG_CODE_NOT_FOUND: 'Código não encontrado no catálogo fiscal.',
  FISCAL_NCM_CODE_DUPLICATE: 'Este código NCM já existe no catálogo global.',
  FISCAL_OPERATION_DEFINITION_ALREADY_EXISTS: 'Definição de operação já cadastrada.',
  FISCAL_COUNTERPARTY_ROLE_REQUIRED:
    'Informe o cliente ou fornecedor no documento antes de calcular.',
  FISCAL_INVOICE_NOT_FOUND: 'Documento fiscal não encontrado.',
  FISCAL_NCM_REQUIRED: 'NCM obrigatório no item — configure o perfil fiscal do produto.',
  FISCAL_NFSE_NATIONAL_CODE_REQUIRED:
    'Informe o código de tributação nacional (cTribNac) no perfil fiscal do serviço.',
  FISCAL_TAX_PROFILE_NOT_FOUND: 'Perfil tributário da filial não encontrado para a competência.',
  FISCAL_RULE_SET_NOT_ACTIVE: 'Motor de regras sem versão ativa na filial.',
  FISCAL_PRODUCT_PROFILE_REQUIRED: 'Produto sem perfil fiscal vigente.',
  FISCAL_INVALID_STATUS_FOR_REVIEW: 'Status do documento não permite esta operação.',
  FISCAL_RECALCULATION_FAILED: 'Não foi possível recalcular os impostos após o ajuste comercial.',
  FISCAL_EMISSION_NOT_APPROVED:
    'Aprove a emissão antes de emitir o documento (status PENDING_AUTHORIZATION).',
  FISCAL_EMISSION_ALREADY_IN_FLIGHT:
    'Já existe uma emissão em andamento para este documento. Aguarde o retorno do processador.',
  FISCAL_EMISSION_PAYLOAD_INCOMPLETE:
    'Dados fiscais incompletos para emissão. Revise destinatário, itens ou pagamento na ficha.',
  FISCAL_CANCEL_DEADLINE_EXCEEDED: 'O prazo de 24 horas para cancelamento desta nota já expirou.',
  FISCAL_CANCEL_JUSTIFICATION_INVALID:
    'A justificativa do cancelamento deve ter entre 15 e 255 caracteres.',
  FISCAL_CANCELLATION_ALREADY_IN_FLIGHT:
    'Já existe um cancelamento em andamento para este documento. Aguarde o retorno do processador.',
  FISCAL_INVOICE_ALREADY_CANCELLED: 'Este documento já está cancelado.',
  FISCAL_NFE_VALIDATION_FAILED: 'Validação NF-e bloqueou o envio. Corrija os erros listados.',
  FISCAL_CERTIFICATE_EXPIRED: 'Certificado digital da filial vencido ou ausente.',
  FISCAL_DOCUMENT_IMMUTABLE: 'Documento autorizado não pode ser alterado.',
  FISCAL_ARTIFACT_NOT_AVAILABLE:
    'DANFE ou XML ainda não disponível. Aguarde a autorização ou confira os artefatos.',
  PAYMENT_NOT_FOUND: 'Pagamento não encontrado.',
  FINANCE_PAYMENT_SOURCE_INVALID: 'Origem do pagamento inválida. Recarregue a comanda.',
  FINANCE_PAYMENT_SUM_MISMATCH: 'A soma das formas de pagamento não bate com o total devido.',
  FINANCE_COMANDA_NOT_FOUND: 'Comanda não encontrada. Recarregue a lista.',
  FINANCE_COMANDA_ALREADY_SETTLED: 'Esta comanda já foi quitada.',
  FINANCE_ACCOUNT_NOT_LEAF: 'Selecione uma conta analítica. Contas sintéticas só agrupam.',
  FINANCE_ACCOUNT_CODE_INVALID: 'Código já em uso ou inconsistente com a conta-pai.',
  FINANCE_ACCOUNT_IN_USE: 'Conta arquivada. Selecione uma conta ativa.',
  FINANCE_ACCOUNT_NOT_FOUND: 'Conta financeira não encontrada. Recarregue a lista.',
  FINANCE_ACCOUNT_INSUFFICIENT_BALANCE:
    'Saldo insuficiente na conta financeira selecionada para concluir a baixa.',
  FINANCE_CASH_ACCOUNT_LIMIT:
    'Já existe uma conta espécie (caixa) ativa nesta oficina. Arquive a atual para criar outra.',
  FINANCE_FINANCIAL_ACCOUNT_ARCHIVED: 'Esta conta financeira já está arquivada.',
  FINANCE_CASH_SESSION_NOT_FOUND: 'Sessão de caixa não encontrada.',
  FINANCE_CASH_SESSION_ALREADY_OPEN: 'Já existe uma sessão de caixa aberta nesta oficina.',
  FINANCE_CASH_SESSION_NOT_OPEN: 'Abra a sessão de caixa antes de registrar sangria ou suprimento.',
  FINANCE_CASH_SESSION_COUNT_MISMATCH:
    'A contagem de espécie não confere com o saldo do caixa. Reconte ou ajuste os movimentos.',
  FINANCE_ACCOUNT_PARENT_REQUIRED: 'Selecione uma conta-pai do tipo grupo (sintética).',
  FINANCE_ACCOUNT_SYSTEM_IMMUTABLE:
    'Conta do sistema não pode ser arquivada nem ter a classificação alterada.',
  FINANCE_ACCOUNT_KEY_DUPLICATE: 'Esta conta já está cadastrada no plano.',
  FINANCE_ENTRY_SOURCE_INVALID: 'Origem do lançamento inválida. Recarregue o documento.',
  FINANCE_PERIOD_CLOSED: 'Competência já fechada. Estorne o fechamento para lançar.',
  FINANCE_CLOSE_ALREADY_CONFIRMED: 'Fechamento desta competência já foi confirmado.',
  FINANCE_CLOSE_BLOCKED_UNCLASSIFIED:
    'Fechamento bloqueado — há saldo na conta transitória a classificar.',
  FINANCE_REVERSAL_REASON_REQUIRED: 'Informe o motivo do estorno do fechamento.',
  FINANCE_INBOUND_PAYABLE_REQUIRED:
    'Selecione a conta de despesa e confirme os dados financeiros da entrada.',
  FINANCE_INBOUND_SCHEDULE_REQUIRED: 'Informe ao menos uma parcela para o contas a pagar.',
  FINANCE_INBOUND_PAYABLE_DUPLICATE:
    'O contas a pagar desta NF-e já foi criado. Não registre a entrada novamente.',
  FINANCE_PO_INBOUND_PAYABLE_CONFLICT:
    'A NF de entrada não pode ser registrada porque o pedido de compra já foi baixado no contas a pagar.',
  FINANCE_PO_INBOUND_MATCH_AMBIGUOUS:
    'Há mais de um pedido recebido com o mesmo número de NF. Resolva os pedidos antes de importar a nota.',
  FINANCE_PAYMENT_METHOD_NOT_READY:
    'Esta forma de pagamento não está pronta. Confira a habilitação, a taxa e a conta de liquidação.',
  FINANCE_PAYMENT_METHOD_FEE_NOT_CONFIGURED:
    'Taxa desta forma de pagamento não configurada. Abra Financeiro → Parametrização e informe a taxa.',
  FINANCE_ITEM_ACCOUNT_UNRESOLVED:
    'Não foi possível classificar o lançamento. Confira a conta no plano e os padrões do produto, do grupo ou da forma de pagamento.',
  FINANCE_CHARGE_ALLOCATION_MISMATCH:
    'O rateio do encargo não fechou com o total. Revise os valores da nota.',
  FINANCE_RECOVERABLE_TAX_UNRESOLVED:
    'Conta de crédito do tributo recuperável não encontrada no plano. Confira o plano base e o regime da unidade.',
  PAYABLE_NOT_FOUND: 'Título a pagar não encontrado. Recarregue a lista.',
  PAYABLE_ALREADY_PAID: 'Este título já foi baixado ou cancelado.',
  PAYABLE_ORIGIN_NOT_EDITABLE: 'Este título não pode ser editado. Abra o detalhe somente leitura.',
  PAYABLE_ORIGIN_NOT_CANCELLABLE:
    'Este título não pode ser cancelado aqui. Cancele pela NF de entrada ou pelo pedido de compra.',
  RECEIVABLE_NOT_FOUND: 'Título a receber não encontrado. Recarregue a lista.',
  RECEIVABLE_ALREADY_PAID: 'Este título já foi recebido ou cancelado.',
  RECEIVABLE_ORIGIN_NOT_EDITABLE:
    'Este título não pode ser editado. Abra o detalhe somente leitura.',
  RECEIVABLE_ORIGIN_NOT_CANCELLABLE:
    'Este título não pode ser cancelado aqui. Títulos gerados por OS seguem o fluxo da OS.',
  FINANCE_CUSTOMER_REQUIRED: 'Selecione um cliente cadastrado para este título.',
  FINANCE_PAYEE_REQUIRED: 'Selecione um fornecedor cadastrado para este título.',
  FINANCE_PROVIDER_NOT_SUPPORTED:
    'Provedor ou layout CNAB não suportado para este banco/canal. Revise o convênio.',
  FINANCE_CHARGE_RECEIVABLE_REQUIRED: 'Vincule um título a receber OPEN para emitir a cobrança.',
  FINANCE_COLLECTION_CHARGE_NOT_FOUND: 'Cobrança bancária não encontrada. Recarregue a lista.',
  FINANCE_COLLECTION_CHARGE_INVALID: 'Cobrança inválida para esta operação. Revise o status.',
  FINANCE_REMITTANCE_CHANNEL_FAILED:
    'Falha ao gerar ou ler o arquivo CNAB. Confira o layout do convênio e tente novamente.',
  FINANCE_BOLETO_BANK_UNSUPPORTED:
    'Banco do convênio sem suporte a boleto local. Use 237, 001, 341, 033 ou 104.',
  FINANCE_BOLETO_RENDER_FAILED: 'Não foi possível gerar o boleto PDF. Revise os dados do convênio.',
  FINANCE_BANK_AGREEMENT_NOT_FOUND: 'Convênio bancário não encontrado. Recarregue a lista.',
  FINANCE_BANK_AGREEMENT_INVALID: 'Convênio inválido. Revise canais e campos obrigatórios.',
  FINANCE_BANK_AGREEMENT_ARCHIVED: 'Este convênio já está arquivado.',
  FINANCE_OPEN_FINANCE_CONNECTION_NOT_FOUND: 'Conexão Open Finance não encontrada.',
  FINANCE_OPEN_FINANCE_INVALID: 'Conexão Open Finance inválida. Reconecte a conta.',
  FINANCE_MALVO_OPEN_FINANCE_DISABLED:
    'Open Finance desativado nesta oficina. Ative em Pagamentos → Open Finance.',
  FINANCE_PAYMENT_SETTINGS_NOT_FOUND: 'Configurações de pagamento não encontradas.',
  FINANCE_SMART_TEF_PROVISION_FAILED:
    'Não foi possível provisionar a loja Smart TEF. Tente reenviar o provisionamento.',
  FINANCE_SMART_TEF_PORTAL_USER_SYNC_FAILED:
    'Não foi possível sincronizar o portal TEF. Confira a senha e tente de novo.',
  FINANCE_SMART_TEF_WEBHOOK_NOT_CONFIGURED:
    'Webhook Smart TEF ainda não está configurado na plataforma.',
  FINANCE_SMART_TEF_WEBHOOK_SYNC_FAILED:
    'Não foi possível registrar o webhook. A liquidação por consulta automática permanece disponível.',
  smart_tef_store_not_active:
    'A loja Smart TEF ainda não está ativa. Reenvie o provisionamento e tente de novo.',
  place_not_found: 'Unidade não encontrada.',
  FINANCE_STATEMENT_INGEST_FAILED: 'Não foi possível importar o extrato OFX. Verifique o arquivo.',
  FINANCE_BANK_STATEMENT_NOT_FOUND: 'Extrato bancário não encontrado.',
  FINANCE_BANK_STATEMENT_LINE_INVALID: 'Linha do extrato inválida para conciliação.',
  SERVICE_ORDER_PAYMENT_PENDING:
    'Registre o pagamento no Caixa antes de fechar a OS ou gerar a NF.',
  NOTIFICATION_CAMPAIGN_NOT_FOUND: 'Campanha não encontrada nesta unidade.',
  NOTIFICATION_CAMPAIGN_INVALID:
    'Revise nome, título, texto, agenda, recorrência, canais e os destinatários da campanha.',
  NOTIFICATION_CAMPAIGN_PRESET_CONFLICT:
    'Já existe uma campanha automática ativa deste tipo nesta unidade.',
  NOTIFICATION_CAMPAIGN_AI_UNAVAILABLE:
    'Assistente de IA indisponível no momento. Preencha título e texto manualmente.',
  NOTIFICATION_CAMPAIGN_AI_INVALID: 'Briefing inválido para gerar conteúdo com IA.',
  NOTIFICATION_TEMPLATE_INVALID: 'O texto do modelo de notificação está inválido.',
  NOTIFICATION_CONFIG_INVALID: 'Revise as flags e os textos-modelo de notificação da unidade.',
  NOTIFICATION_PLACE_NOT_FOUND: 'Unidade não encontrada.',
  NOTIFICATION_PARTY_NOT_FOUND: 'Cliente não encontrado.',
  NOTIFICATION_WHATSAPP_PAIRING_QR_UNAVAILABLE:
    'O QR ainda está sendo gerado. A tela atualiza sozinha.',
  NOTIFICATION_WHATSAPP_INBOX_MESSAGE_NOT_OWN:
    'Só dá para editar ou apagar para todos uma mensagem enviada por esta oficina.',
  NOTIFICATION_WHATSAPP_INBOX_MESSAGE_ACTION_FAILED:
    'O WhatsApp não aceitou essa alteração. Mensagens antigas não podem ser editadas ou apagadas para todos.',
  FISCAL_SO_NOT_ELIGIBLE:
    'A ordem de serviço não está elegível para gerar NF (status deve ser pronta para entrega).',
  FISCAL_SO_NO_PRODUCT_ITEMS: 'Não há peças concluídas para incluir na nota fiscal.',
  FISCAL_SO_NO_BILLABLE_ITEMS: 'Não há peças ou serviços concluídos para gerar notas fiscais.',
  FISCAL_SO_DOCUMENT_KIND_ALREADY_EXISTS:
    'Já existe uma nota ativa deste tipo para a ordem de serviço.',
  FISCAL_SO_ITEM_MISMATCH: 'Os valores da OS não batem com o rascunho fiscal. Revise os itens.',
  FISCAL_CAIXA_BLOCKED_BY_PENDING:
    'Há pendências fiscais que impedem a quitação no Caixa. Complete o cadastro/operações ou ajuste a política da filial.',
  FISCAL_PENDING_OBLIGATION_NOT_FOUND: 'Obrigação fiscal pendente não encontrada.',
  CONVERSATION_CONSUMER_ACCOUNT_REQUIRED: 'Este cliente ainda não tem conta no app.',
  CONVERSATION_AUDIO_INVALID: 'Grave um áudio de até 5 minutos no formato permitido.',
  CONVERSATION_WORKSHOP_UNAVAILABLE: 'Esta oficina não participa do chat no app.',
  CUSTOMER_PORTAL_LINK_NOT_FOUND: 'Este link não está mais disponível.',
  CUSTOMER_PORTAL_LINK_EXPIRED: 'Este link expirou. Peça um novo para a oficina.',
  CUSTOMER_PORTAL_LINK_ALREADY_SIGNED: 'Este documento já foi assinado.',
  CUSTOMER_PORTAL_DECISION_INVALID: 'Marque cada item como aprovado ou recusado e assine.',
} as const;

export type ErrorMessageCode = keyof typeof errorMessages;

export function translateError(code: string, fallback?: string): string {
  if (code in errorMessages) {
    return errorMessages[code as ErrorMessageCode];
  }

  return fallback ?? errorMessages.HTTP_ERROR;
}
